<p-confirmDialog [position]="dialogPosition" key="dialog"/>
<p-block-ui [blocked]="loading" [target]="content"></p-block-ui>
<app-blockable-div #content>
  <div class="container grid mb-8">
    <div class="col-12">
      @if (!movieId) {
        <h1>Aggiungi titolo</h1>
      } @else {
        <h1>Modifica titolo</h1>
      }
    </div>

    <div class="col-6 flex">
      <label class="inline-block" [style.width]="'120px'">Copertina<br>in italiano</label>
      <app-media-selector [mediaSourceId]="italianDetail.coverImageId ?? 0"
                          (mediaSourceIdChange)="italianDetail.coverImageId = $event"></app-media-selector>
    </div>
    <div class="col-6 flex">
      <label class="inline-block" [style.width]="'120px'">Copertina<br>in inglese</label>
      <app-media-selector [mediaSourceId]="englishDetail.coverImageId ?? 0"
                          (mediaSourceIdChange)="englishDetail.coverImageId = $event"></app-media-selector>
    </div>


    <div class="col-6 flex">
      <label class="inline-block" [style.width]="'120px'">Immagine per carosello<br>in italiano</label>
      <app-media-selector [mediaSourceId]="italianDetail.sliderImageId ?? 0"
                          (mediaSourceIdChange)="italianDetail.sliderImageId = $event"
                          category="slider"
                          canvasWidth="240px" canvasHeight="135px"
      ></app-media-selector>
    </div>
    <div class="col-6 flex">
      <label class="inline-block" [style.width]="'120px'">Immagine per carosello<br>in inglese</label>
      <app-media-selector [mediaSourceId]="englishDetail.sliderImageId ?? 0"
                          (mediaSourceIdChange)="englishDetail.sliderImageId = $event"
                          category="slider"
                          canvasWidth="240px" canvasHeight="135px"
      ></app-media-selector>
    </div>

    <div class="col-12 md:col-6">
      <app-input type="text" label="Titolo italiano" [maxLength]="300" [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 placeholder="Inserisci il titolo del film"
                 [(model)]="italianDetail.title"/>

    </div>
    <div class="col-12 md:col-6">
      <app-input type="text" label="Titolo inglese" [maxLength]="300" [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 placeholder="Inserisci il titolo del film"
                 [(model)]="englishDetail.title"/>

    </div>

    <div class="col-12">
      <app-input type="number" label="Anno uscita" [maxLength]="300" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="movie.year"/>

    </div>
    <div class="col-12">
      <app-input type="text" label="Regia" [maxLength]="300" placeholder="Nome cognome regia"
                 [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 [(model)]="movie.direction"/>
    </div>

    <div class="col-12 md:col-6">
      <app-input type="text" label="Produzione ita." [maxLength]="300" [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 placeholder="Nome della casa di produzione in italiano"
                 [(model)]="italianDetail.production"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="text" label="Produzione ing." [maxLength]="300" [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 placeholder="Nome della casa di produzione in inglese"
                 [(model)]="englishDetail.production"/>
    </div>

    <div class="col-12">
      <app-input type="text" label="Cast" [maxLength]="300" [labelWidth]="labelWidth"
                 class="mr-4" [fullWidth]="true" [showLength]="false" autocomplete="off"
                 placeholder="Nome Cognome, Nome Cognome, ..."
                 [(model)]="movie.cast"/>
    </div>

    <div class="col-12">
      <div style="display: inline-block" class="flex">
        <label [style.width]="labelWidth" style="flex-shrink: 0; display: inline-block">Genere</label>
        <p-multiSelect [options]="genres | appPojo"
                       [style.width]="'100%'" [style.max-width]="'100%'"
                       optionLabel="name"
                       optionValue="movieGenreId"
                       [panelStyle]="{'width': '100%'}"
                       appendTo="body"
                       [(ngModel)]="movieGenres"
                       [autofocusFilter]="true"
                       [filter]="true"
                       [resetFilterOnHide]="true"
                       placeholder="Nessuna selezione"
                       [maxSelectedLabels]="6"
        >
          <ng-template #footer>
            <div class="p-3 flex justify-between">
              <p-button label="Aggiungi un nuovo genere" severity="secondary" text size="small"
                        icon="pi pi-plus"
                        (click)="createGenre('Genre')"/>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>

    <div class="col-12">
      <div style="display: inline-block" class="flex">
        <label [style.width]="labelWidth" style="flex-shrink: 0; display: inline-block">Sotto genere</label>
        <p-multiSelect [options]="subGenres | appPojo"
                       [style.width]="'100%'" [style.max-width]="'100%'"
                       optionLabel="name"
                       optionValue="movieGenreId"
                       [panelStyle]="{'width': '100%'}"
                       appendTo="body"
                       [(ngModel)]="movieSubGenres"
                       [autofocusFilter]="true"
                       [filter]="true"
                       [resetFilterOnHide]="true"
                       placeholder="Nessuna selezione"
                       [maxSelectedLabels]="12"
        >
          <ng-template #footer>
            <div class="p-3 flex justify-between">
              <p-button label="Aggiungi un nuovo sotto genere" severity="secondary" text size="small"
                        icon="pi pi-plus"
                        (click)="createGenre('SubGenre')"/>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>

    <div class="col-12">
      <app-datetime label="LTR" [labelWidth]="labelWidth"
                    placeholder="Seleziona la data"
                    [model]="movie.ltr" (modelChange)="updateLtr($event)"
                    [showTime]="false"></app-datetime>

    </div>

    <div class="col-12 md:col-6">
      <app-input type="text" label="Info in italiano" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="italianDetail.info"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="text" label="Info in inglese" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="englishDetail.info"/>
    </div>

    <hr/>

    <!-- IMDB / TRAILER -->
    <div class="col-12 md:col-6">
      <app-input type="text" label="Link IMDB italiano" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px" placeholder="Iserisci il link"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="italianDetail.linkImdb"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(italianDetail.linkImdb)"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="text" label="Link IMDB inglese" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px" placeholder="Iserisci il link"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="englishDetail.linkImdb"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(englishDetail.linkImdb)"/>
    </div>

    <div class="col-12 md:col-6">
      <app-input type="text" label="Link Trailer italiano" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px" placeholder="Iserisci il link"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="italianDetail.linkTrailer"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(italianDetail.linkTrailer)"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="text" label="Link Trailer inglese" [maxLength]="1024" [labelWidth]="labelWidth"
                 [fullWidth]="true" inputWidth="300px" placeholder="Iserisci il link"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="englishDetail.linkTrailer"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(englishDetail.linkTrailer)"/>
    </div>

    <!-- B.O. -->
    <div class="col-12">
      <app-input type="number" label="B.O." placeholder="Inserisci la cifra in euro" [maxLength]="300"
                 [labelWidth]="labelWidth"
                 [fullWidth]="false" inputWidth="300px"
                 [showLength]="false" [minValue]="1800" autocomplete="off"
                 [(model)]="movie.boxOffice"/>
    </div>

    <!-- PREMI IN ITALIANO / INGLESE -->
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Premi italiano" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 placeholder="Elenco dei premi in italiano, separati da una virgola"
                 [(model)]="italianDetail.awards"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(italianDetail.awards)"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Premi inglese" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 placeholder="Elenco dei premi in inglese, separati da una virgola"
                 [(model)]="englishDetail.awards"
                 actionButtonType="link" [isActionTextButton]="true"
                 (action)="openLink(englishDetail.awards)"/>
    </div>
    <hr/>

    <!-- SINOSSI -->
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Sinossi italiano" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 placeholder="Testo della sinossi in italiano"
                 [maxLength]="2048"
                 [(model)]="italianDetail.synopsis"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Sinossi inglese" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 placeholder="Testo della sinossi in inglese"
                 [maxLength]="2048"
                 [(model)]="englishDetail.synopsis"/>
    </div>

    <hr/>
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Other producers" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 [maxLength]="1024"
                 [(model)]="movie.otherProducers"/>
    </div>
    <div class="col-12 md:col-6">
      <app-input type="textarea" label="Production Budget" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 [maxLength]="1024"
                 [(model)]="movie.productionBudget"/>
    </div>

    <div class="col-12 md:col-4">
      <app-dropdown [(model)]="movie.skyMovieRights"
                    label="Rights Sky" [labelWidth]="labelWidth"
                    optionValue="value" optionLabel="label"
                    [showClear]="false" [showFilter]="true"
                    [createItemOnFly]="false"
                    [dropdownItems]="SkyMovieRightsList"
      />
    </div>

    <div class="col-12 md:col-4">
      <app-dropdown [model]="displayedCalculationMode"
                    (modelChange)="updateCalculationMode($event)"
                    label="Automatismi" [labelWidth]="labelWidth"
                    optionValue="value" optionLabel="label"
                    [showClear]="false" [showFilter]="false"
                    [createItemOnFly]="false"
                    [dropdownItems]="MovieCalculationModeList"
      />
    </div>

    <div class="col-12 md:col-4">
      @if (movie.skyMovieRights == SkyMovieRights.CoExclusive) {
        <app-dropdown [(model)]="movie.skyCoExclusiveSoldStatus"
                      label="Notes Pay 1 / SVOD 1 CoExclusive" [labelWidth]="labelWidth"
                      optionValue="value" optionLabel="label"
                      [showClear]="false" [showFilter]="true"
                      [createItemOnFly]="false"
                      [dropdownItems]="skyCoExclusiveSoldStatusList"
        />
      }
    </div>

    <hr/>

    <div class="col-12">
      <div class="row flex flex-wrap justify-content-between">
        <app-datetime [showClear]="true" label="First Tx Sky"
                      [labelWidth]="labelWidth"
                      [model]="movie.firstTxSky" (modelChange)="updateFirstTxSky($event)"
                      [showTime]="false"></app-datetime>
        <app-checkbox label="Special (~&euro;8m)" [model]="movie.special8M"
                      (modelChange)="updateSpecial8m($event)"></app-checkbox>
        <app-checkbox [(model)]="movie.showAvailability" label="Mostra colonna disponibilità"></app-checkbox>
      </div>

      <p-table #table styleClass="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
               [lazy]="false" [value]="movie.movieAvailability"
               [rows]="1000"
               [rowsPerPageOptions]="[1000]"
               [totalRecords]="movie.movieAvailability.length"
               [paginator]="false"
               [rowHover]="true"
               [loading]="loading"
               [autoLayout]="true"
               responsiveLayout="stack">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>Finestra</th>
            <th>Stato</th>
            <th>Disponibile</th>
            <th>Mesi</th>
            <th>Scadenza</th>
            <th>Modalità</th>
            <th>Tentative</th>
            <th>Disponibilità/cliente</th>
            <th>Note</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex">
          @let row = obj(item);
          <tr class="border-top-highlight">
            <td> @if (index > 2) {
              <p-button variant="text" class="p-button-text"
                        (click)="removeAvailability(row)">
                <i class="pi pi-trash"></i>
              </p-button>
            }
            </td>
            <td class="title">
              @if (index <= 2) {
                {{ row.window | appWindowLabel }}
              } @else {
                <app-dropdown [(model)]="row.window"
                              optionValue="value" optionLabel="label"
                              [showClear]="false" [showFilter]="true"
                              [createItemOnFly]="false"
                              [dropdownItems]="MovieAvailabilityLimitedWindowList"
                />
              }
            </td>
            <td>
              <app-dropdown [(model)]="row.status"
                            optionValue="value" optionLabel="label"
                            [showClear]="true" [showFilter]="true"
                            [createItemOnFly]="false"
                            [dropdownItems]="MovieAvailabilityStatusList"
                            inputWidth="150px"
              ></app-dropdown>
            </td>
            <td>
              @if (isFormulaMode && index <= 2) {
                {{ row.from | date:'dd/MM/yyyy' }}
              } @else {
                <app-datetime class="availability-date" [showClear]="!isFormulaMode"
                              [labelWidth]="labelWidth" placeholder="DD/MM/YYYY"
                              [model]="row.from" (modelChange)="updateMovieFrom(row, $event)"
                              [showTime]="false"></app-datetime>
              }
            </td>
            <td>
              <app-input type="number" [minValue]="0" [maxValue]="36" [showLength]="false" [model]="row.months"
                         inputWidth="60px"
                         [disabled]="isFormulaMode && index < 2"
                         (modelChange)="updateMovieMonths(row, $event)"/>
            </td>
            <td>
              @if (isFormulaMode) {
                @if (!!row.from && row.expiration && row.expiration > row.from && row.months > 0) {
                  {{ row.expiration | date:'dd/MM/yyyy' }}
                }
              } @else {
                <app-datetime class="availability-date" [showClear]="true"
                              [labelWidth]="labelWidth" placeholder="DD/MM/YYYY"
                              [model]="row.expiration"
                              (modelChange)="updateMovieExpiration(row, $event)"
                              [showTime]="false"></app-datetime>
              }
            </td>
            <td>
              <app-dropdown [model]="row.movieRights" (modelChange)="updateMovieRights(row, $event)"
                            optionValue="value" optionLabel="label"
                            [showClear]="true" [showFilter]="true"
                            [createItemOnFly]="false"
                            [disabled]="isFormulaMode && row.window === Window.Pay2"
                            [dropdownItems]="MovieAvailabilityRightsList"
                            inputWidth="150px"
              />
            </td>
            <td>
              @if (row.window === Window.Pay1) {
                <app-dropdown [(model)]="movie.tentative"
                              optionValue="value" optionLabel="label"
                              [showClear]="false" [showFilter]="true"
                              [createItemOnFly]="false"
                              [dropdownItems]="MovieTentativeList"
                              inputWidth="90px"
                />
              } @else {
                <app-dropdown [(model)]="row.tentative"
                              optionValue="value" optionLabel="label"
                              [showClear]="false" [showFilter]="true"
                              [createItemOnFly]="false"
                              [dropdownItems]="MovieTentativeList"
                              inputWidth="90px"
                />
              }
            </td>
            <td>
              <app-input type="text" [showLength]="false" [(model)]="row.customerName"></app-input>
            </td>
            <td>
              <i class="pi pi-info-circle mr-2 clickable"
                 [pTooltip]=" row.note " tooltipPosition="left" appendTo="body"
                 (click)="showNoteEditor(row)"></i>
            </td>
          </tr>
          @if (row.window === Window.Svod) {
            <tr class="align-right-content">
              <td></td>
              <td></td>
              <td colspan="2">
                @if (row.status === MovieAvailabilityStatus.Current) {
                  <app-input label="Previous platform" useFloatLabel="on"
                             type="text" [showLength]="false"
                             [maxLength]="1024"
                             [(model)]="row.svodCurrentPreviousPlatform"/>
                } @else if (row.status === MovieAvailabilityStatus.Library) {
                  <app-input label="TBC" useFloatLabel="on"
                             type="text" [showLength]="false"
                             [maxLength]="8"
                             [(model)]="row.svodLibraryTbc"/>
                }
              </td>
              <td></td>
              <td></td>
              <td></td>

            </tr>
          }

          @if (row.window === Window.FreeTv) {
            <tr class="align-right-content">
              <td></td>
              <td></td>
              <td colspan="2">
                <app-input label="Tentativ" useFloatLabel="on"
                           type="text" [showLength]="false"
                           [maxLength]="8"
                           [(model)]="row.freeTvTentativ"/>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          }
        </ng-template>
      </p-table>
      <div class="mt-4">
        <div class="flex flex-row justify-content-between">
          <app-action-button label="+ Aggiungi finestra" (click)="addAvailability()"></app-action-button>
        </div>
      </div>
      <hr>
    </div>


    <div class="col-12">
      <app-input type="textarea" label="Note" [labelWidth]="labelWidth"
                 [fullWidth]="true" [showLength]="false"
                 placeholder="Inserisci le note"
                 [(model)]="movie.note"
      />
    </div>

    @if (movie.published) {
      <div style="text-align: right; font-size: 0.8rem" class="fullWidth">
        <i>Pubblicato il {{ movie.publishedAt | date:'dd/MM/yyyy' }}</i>
      </div>
    }

    <div class="flex flex-row justify-content-between fullWidth mt-4 mb-8">
      <p-button variant="outlined" icon="pi pi-trash"
                label="Elimina titolo" pRipple severity="danger"
                (click)="deleteTitle()"></p-button>
      <div class="flex flex-row">
        @if (!movie.published) {
          <p-button icon="pi pi-save" label="Salva bozza" pRipple (click)="save()"
                    [disabled]="loading"></p-button>
          <p-button variant="outlined" icon="pi pi-check" label="Pubblica" pRipple class="ml-2"
                    (click)="save('publish')" [disabled]="loading"></p-button>
        } @else {
          <p-button variant="outlined" icon="pi pi-undo" label="Riporta in bozza" pRipple
                    (click)="save('unpublish')"
                    class="ml-2" [disabled]="loading"></p-button>
          <p-button icon="pi pi-save" label="Aggiorna" pRipple class="ml-2" (click)="save()"
                    [disabled]="loading"></p-button>
        }
      </div>
    </div>

  </div>
</app-blockable-div>

<p-dialog [modal]="true" header="Modifica la nota per {{ (editingRow?.window || '') | appWindowLabel }}" [(visible)]="displayNoteDialog"
          [style]="{width: '50vw', height: '30vh'}" appendTo="body">
  @if (editingRow) {
    <textarea #textarea pTextarea [autoResize]="true"
              style="resize: none; overflow-y: auto"
              [(ngModel)]="editingRow.note"
              [maxlength]="2048"
              [style.width]="'100%'" [rows]="8"
    ></textarea>
  }
  <div class="flex justify-end mt-4">
    <p-button label="OK" (click)="displayNoteDialog = false"/>
  </div>
</p-dialog>
